import React from "react"

import { colors } from "@bullseye/tailwind-config"

import { IconProps } from "./IconProps"

const GroupsIcon: React.FC<IconProps> = ({
  scale = 1,
  lineScale = 1,
  color = colors.orange[500],
  bgColor = colors.orange[50],
  outline = true,
  ...rest
}) => (
  <svg
    viewBox="0 0 48 48"
    width={scale * 48}
    height={scale * 48}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Groups"
    {...rest}
  >
    {outline && <rect width="48" height="48" rx="24" fill={bgColor} />}
    <g clipPath="url(#clip0_534_13137)">
      <path
        d="M28.5 33V31C28.5 29.9391 28.0786 28.9217 27.3284 28.1716C26.5783 27.4214 25.5609 27 24.5 27H16.5C15.4391 27 14.4217 27.4214 13.6716 28.1716C12.9214 28.9217 12.5 29.9391 12.5 31V33"
        stroke={color}
        strokeWidth={lineScale * 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 23C22.7091 23 24.5 21.2091 24.5 19C24.5 16.7909 22.7091 15 20.5 15C18.2909 15 16.5 16.7909 16.5 19C16.5 21.2091 18.2909 23 20.5 23Z"
        stroke={color}
        strokeWidth={lineScale * 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.5 33V31C34.4993 30.1137 34.2044 29.2528 33.6614 28.5523C33.1184 27.8519 32.3581 27.3516 31.5 27.13"
        stroke={color}
        strokeWidth={lineScale * 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5 15.13C28.3604 15.3503 29.123 15.8507 29.6676 16.5523C30.2122 17.2539 30.5078 18.1168 30.5078 19.005C30.5078 19.8932 30.2122 20.7561 29.6676 21.4577C29.123 22.1593 28.3604 22.6597 27.5 22.88"
        stroke={color}
        strokeWidth={lineScale * 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_534_13137">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(11.5 12)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default GroupsIcon
